export default "__VITE_ASSET__bf7f76c5__"